import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';

type Props = {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  className?: string;
};

export const BottomLink = ({ label = '', icon, onClick, className }: Props) => (
  <Button
    aria-label={label}
    className={cn(
      'font-normal normal-case hover:brightness-95 dark:hover:brightness-125',
      className
    )}
    data-cy={`to-${label.replace(' ', '-').toLowerCase()}`}
    data-testid={`to-${label.replace(' ', '-').toLowerCase()}`}
    onClick={onClick}
    size="sm"
    type="button"
    variant="ghost"
  >
    {icon && icon} {label}
  </Button>
);
